import { Flex, Text, Image } from "@chakra-ui/react"

const UnderHeader = () => {
  return (
    <Flex
      flexDirection={["column", "row", "row"]}
      alignItems="center"
      justifyContent="center"
      width="80vw"
      boxShadow="md"
      paddingLeft={["24px", "16px", "16px"]}
      paddingRight={["24px", "16px", "16px"]}
      paddingTop={["32px", "24px", "24px"]}
      paddingBottom={["32px", "24px", "24px"]}
      marginTop="-24px"
      backgroundColor="white"
      borderRadius="4px"
    >
      <Image
        src="/cez-confort-asigurat/assets/help.png"
        marginLeft="16px"
        marginRight="16px"
        marginBottom={["16px", "16px", "0px", "0px"]}
      />
      <Text textAlign="center">
        Semneaza un contract{" "}
        <span style={{ color: "#FF5722" }}>
          <strong>CEZ Confort Asigurat</strong>
        </span>{" "}
        si, daca se intampla ceva cu locul tau de munca sau chiar in caz de
        imbolnavire cu virusul Sars-CoV-2,{" "}
        <span style={{ color: "#FF5722" }}>
          <strong>preluam noi plata facturii de energie timp de 6 luni</strong>
        </span>
        .
      </Text>
    </Flex>
  )
}

export default UnderHeader
